{
  "name": "underatom",
  "author": "playdev",
  "license": "MIT",
  "version": "0.1.2",
  "description": "Ambitious Component Library Builder. Choose your favorite Framework, Headless, CSS library and Design System.",
  "homepage": "https://github.com/underatom-org/underatom#readme",
  "repository": {
    "type": "git",
    "url": "https://github.com/underatom-org/underatom.git"
  },
  "bugs": {
    "url": "https://github.com/underatom-org/underatom/issues"
  },
  "bin": "./dist/index.js",
  "publishConfig": {
    "access": "public"
  },
  "keywords": [
    "component-library",
    "react",
    "multi-framework",
    "headless",
    "design-system",
    "underatom",
    "ui"
  ],
  "main": "index.js",
  "type": "module",
  "tsup": {
    "entry": [
      "src/index.ts",
      "src/index-docs.ts"
    ],
    "splitting": false,
    "sourcemap": true,
    "clean": true
  },
  "scripts": {
    "build": "tsup --format esm",
    "watch": "tsup --watch --format esm",
    "start": "node dist/index.js",
    "typecheck": "tsc --noEmit",
    "lint": "eslint . --ext .ts,.tsx --resolve-plugins-relative-to . -c .eslintrc",
    "react:tv": "node dist/index-docs.js --dev --name sandbox/tailwind-variants --designSystem eve --stylingLibrary tailwind-variants",
    "watch:react:tv": "watch 'node dist/index-docs.js --dev --watchMode --name sandbox/tailwind-variants --designSystem eve --stylingLibrary tailwind-variants' template/styles template/base/src",
    "pretty": "prettier --write .",
    "test": "jest --no-cache --passWithNoTests",
    "gen:api": "orval",
    "gen:registry": "tsx src/utils/registry/build-components-registry.ts",
    "pub:beta": "pnpm build && pnpm publish --no-git-checks --access public --tag beta",
    "pub:release": "pnpm build && pnpm publish --access public"
  },
  "files": [
    "dist"
  ],
  "devDependencies": {
    "@ark-ui/react": "^3.6.2",
    "@internationalized/date": "^3.5.4",
    "@jest/globals": "^29.7.0",
    "@pandacss/dev": "^0.22.1",
    "@phosphor-icons/react": "^2.0.15",
    "@radix-ui/react-accordion": "^1.1.2",
    "@radix-ui/react-avatar": "^1.0.4",
    "@radix-ui/react-checkbox": "^1.0.4",
    "@radix-ui/react-dropdown-menu": "^2.1.2",
    "@radix-ui/react-progress": "^1.1.0",
    "@radix-ui/react-radio-group": "^1.1.3",
    "@radix-ui/react-select": "^2.0.0",
    "@radix-ui/react-switch": "^1.0.3",
    "@radix-ui/react-tabs": "^1.0.4",
    "@radix-ui/react-toggle-group": "^1.1.0",
    "@tabler/icons-react": "^3.1.0",
    "@tanstack/react-query": "^5.51.11",
    "@tanstack/react-router": "^1.39.4",
    "@types/babel__core": "^7.20.1",
    "@types/diff": "^5.0.3",
    "@types/fs-extra": "^11.0.1",
    "@types/jest": "^29.5.11",
    "@types/lodash.template": "^4.5.1",
    "@types/prompts": "^2.4.2",
    "@types/react": "^18.3.3",
    "@types/react-dom": "^18.3.0",
    "@types/stringify-object": "^4.0.5",
    "@typescript-eslint/eslint-plugin": "^6.9.1",
    "@typescript-eslint/parser": "^6.9.1",
    "@vitejs/plugin-react": "^2.1.0",
    "axe-playwright": "^2.0.1",
    "axios": "^1.7.7",
    "cmdk": "^0.2.1",
    "eslint": "^8.53.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-import-resolver-typescript": "^3.5.2",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-jsx-a11y": "^6.6.1",
    "eslint-plugin-react": "^7.31.11",
    "eslint-plugin-react-hooks": "^4.6.0",
    "jest": "^29.7.0",
    "jotai": "^2.9.1",
    "orval": "^7.1.0",
    "phosphor-react": "^1.4.1",
    "postcss": "^8.4.32",
    "postcss-import": "^15.1.0",
    "posthog-js": "^1.165.0",
    "prettier": "^3.1.1",
    "react": "^18.3.1",
    "react-aria": "^3.34.3",
    "react-aria-components": "^1.2.1",
    "react-dom": "^18.3.1",
    "react-stately": "^3.29.1",
    "rimraf": "^6.0.1",
    "rollup-plugin-banner2": "^1.2.2",
    "rollup-plugin-visualizer": "^5.9.0",
    "supertokens-web-js": "^0.13.0",
    "tailwind-variants": "^0.1.18",
    "tailwindcss": "^3.3.6",
    "ts-jest": "^29.1.2",
    "tsup": "^6.6.3",
    "tsx": "^4.19.1",
    "type-fest": "^3.8.0",
    "typescript": "^4.9.3",
    "vite": "^3.1.0",
    "vite-plugin-dts": "1.0.3",
    "vite-plugin-top-level-await": "^1.3.0",
    "watch": "^1.0.2"
  },
  "dependencies": {
    "@antfu/ni": "^0.21.4",
    "@babel/core": "^7.22.1",
    "@babel/parser": "^7.22.6",
    "@babel/plugin-transform-typescript": "^7.22.5",
    "@clack/prompts": "^0.7.0",
    "commander": "^10.0.0",
    "cosmiconfig": "^8.1.3",
    "deepmerge": "^4.3.1",
    "diff": "^5.1.0",
    "execa": "^7.0.0",
    "fast-glob": "^3.3.2",
    "fs-extra": "^11.1.0",
    "https-proxy-agent": "^6.2.0",
    "kleur": "^4.1.5",
    "lodash.template": "^4.5.0",
    "node-fetch": "^3.3.0",
    "ora": "^6.1.2",
    "postcss": "^8.4.24",
    "prompts": "^2.4.2",
    "recast": "^0.23.2",
    "stringify-object": "^5.0.0",
    "ts-morph": "^18.0.0",
    "tsconfig-paths": "^4.2.0",
    "zod": "^3.20.2"
  }
}